
import React from 'react';
import { Service } from '../types';

interface ServiceCardProps {
  service: Service;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ service }) => {
  const { Icon } = service;
  return (
    <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col items-center text-center h-full">
      <div className="bg-sky-100 p-4 rounded-full mb-4">
        <Icon className="h-10 w-10 text-sky-600" />
      </div>
      <h3 className="text-xl font-semibold text-slate-800 mb-2">{service.title}</h3>
      <p className="text-slate-600 text-sm flex-grow">{service.description}</p>
    </div>
  );
};

export default ServiceCard;
